import { NgModule, ModuleWithProviders } from '@angular/core';
import { IOption } from './http-function-token';
import { HttpFunctionService } from './http-function.service';
import { HTTP_CONFIG } from './http-function-token';



@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [
    HttpFunctionService
  ]
})
export class HttpFunctionModule { 
  constructor(private HttpFunctionService: HttpFunctionService){
  }

  private static options_default: IOption = {
    code: 'code',
    codeValue: '1000000',
    message: 'message',
    data: 'data',
  }

  public static forRoot(options: IOption = HttpFunctionModule.options_default): ModuleWithProviders {
    return {
      ngModule: HttpFunctionModule,
      providers: [
        {
          provide: HTTP_CONFIG,
          useValue: options
        }
      ]
    };
  }
}

